/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Box,
  Heading,
  HStack,
  Spacer,
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverHeader,
  PopoverBody,
  OrderedList,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Spinner,
} from '@chakra-ui/react';
import { useHistory } from '@partiu/api/club/hooks';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import { useTheme } from '../../../contexts/ThemeProvider';

// Helper to format currency
function numberToBRL(value: number) {
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function EconometroList() {
  const { data: econometer, isLoading } = useHistory();

  const { colors } = useTheme();

  const data =
    econometer?.progress?.reduce<any>((a, b) => {
      const progress = [...b.progress_sales];
      progress.reverse();
      return a.concat(progress);
    }, []) ?? [];

  return (
    <Box
      width={'100%'}
      backgroundColor={'white'}
      maxWidth={'100%'}
      padding="20px"
      flexWrap="wrap"
      borderRadius="24px"
      gap={10}
      boxShadow={'4px 4px 10px 0px #0000002E'}
    >
      <HStack>
        <Heading color="#292927" fontSize={'18px'} fontFamily={'Glory'} fontWeight={500}>
          Extrato
        </Heading>
      </HStack>
      <Popover>
        <PopoverTrigger>
          <HStack width={'fit-content'} align={'center'} paddingTop="10px">
            <Text
              textAlign="left"
              color="#495057"
              opacity="0.5"
              fontSize="10pt"
              style={{ textDecoration: 'underline', cursor: 'pointer' }}
            >
              Saiba como é calculada sua economia.
            </Text>
            <IoMdInformationCircleOutline color="#495057" size={20} />
          </HStack>
        </PopoverTrigger>
        <PopoverContent>
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverHeader>Cálculo de Economia</PopoverHeader>
          <PopoverBody fontSize="10pt">
            <Text textAlign="left" paddingBottom="10px">
              Sua economia é calculada de 3 formas:
            </Text>
            <OrderedList textAlign="left" spacing={2} paddingLeft="5px">
              <li>Pelo valor informado do estabelecimento parceiro quando você utilizou o desconto.</li>
              <li>Pelo valor que você informa (se sobrepõe ao valor dele).</li>
              <li>
                Se nenhum dos dois informaram o valor, registramos no Econômetro a economia média do estabelecimento.
              </li>
            </OrderedList>
          </PopoverBody>
        </PopoverContent>
      </Popover>

      <Table>
        <Thead>
          <Tr>
            <Th>Empresa</Th>
            <Th>Data</Th>
            <Th style={{ textAlign: 'right' }}>Economizado</Th>
          </Tr>
        </Thead>
        <Tbody fontSize="14px">
          {!isLoading &&
            data.map((d: any, idx: number) => (
              <Tr key={idx}>
                <Td>{d.company}</Td>
                <Td>{new Date(d.created_at).toLocaleDateString('pt-BR')}</Td>
                <Td textAlign="right">{numberToBRL(d.saved)}</Td>
              </Tr>
            ))}
          {!isLoading && data.length === 0 && (
            <Tr>
              <Td colSpan={3} textAlign="center">
                Nenhum registro encontrado.
              </Td>
            </Tr>
          )}
          {isLoading && (
            <Tr>
              <Td colSpan={3} textAlign="center">
                <Spinner color={colors.primaryColor} />
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>
    </Box>
  );
}
